module.exports = __webpack_public_path__ + "8223473acdaa92a20b57884ff3f33512.pdf";